import { mainService } from '@/utils/request'

// 获取验证码
export function getCodeByPhone (data) {
  return mainService({
    url: 'app2/user/getCode',
    method: 'post',
    data: data
  })
}

// 登录/注册（短信验证登录）
export function loginByPhoneAndCode (data) {
  return mainService({
    url: 'app2/user/login',
    method: 'post',
    data: data
  })
}

// 登出
export function loginOut (data) {
  return mainService({
    url: 'app2/user/logout',
    method: 'post',
    data: data
  })
}

// 更改用户信息
export function updateUserInfo (data) {
  return mainService({
    url: 'app/person/update_info',
    method: 'post',
    data: data
  })
}

// 根据token获取用户信息
export function getUserInfoByToken (token) {
  return mainService({
    url: `/app/person/get_token_author?token=${token}`,
    method: 'post'
  })
}

// 上传图片
export function uploadFile (data) {
  return mainService({
    url: 'app/person/upload_head',
    method: 'post',
    data: data
  })
}

// 摄影师认证
export function photographerAuth (data) {
  return mainService({
    url: 'app/person/certification_cameraman',
    method: 'post',
    data: data
  })
}

// 获取摄影师认证信息
export function getPhotographAuthInfo (data) {
  return mainService({
    url: 'app/person/get_certification_flag',
    method: 'post',
    data: data
  })
}

// 第三方登录
export function thirdLogin (data) {
  return mainService({
    url: 'app/third/third_login',
    method: 'post',
    data: data
  })
}

// 绑定电话
export function boundPhone (data) {
  return mainService({
    url: 'app/third/bound_phone',
    method: 'post',
    data: data
  })
}

// 绑定微信
export function boundWeixin (data) {
  return mainService({
    url: 'app/third/bound_weixin_web',
    method: 'post',
    data: data
  })
}

// 解绑微信
export function relieveboundWeixin (data) {
  return mainService({
    url: 'app/third/untie_weixin',
    method: 'post',
    data: data
  })
}

// 获取作者信息
export function getPhotographerById (data) {
  return mainService({
    url: 'app/person/author_info',
    method: 'post',
    data: data
  })
}

// 关注作者
export function changeUserAttention (data) {
  return mainService({
    url: 'app/interaction/user_attention',
    method: 'post',
    data: data
  })
}

// 获取作者作品数
export function getWorksNumByAuthor (data) {
  return mainService({
    url: 'app/person/get_works_num',
    method: 'post',
    data: data
  })
}

// 获取作者作者列表
export function getAuthorWorksList (data) {
  return mainService({
    url: 'app/person/get_author_works',
    method: 'post',
    data: data
  })
}

// 重新绑定电话
export function updateLoginPhone (data) {
  return mainService({
    url: 'gty/update_phone',
    method: 'post',
    data: data
  })
}

// 获取粉丝/关注列表
export function getLikeAttentionList (data) {
  return mainService({
    url: 'app/interaction/get_like_att_list',
    method: 'post',
    data: data
  })
}

// 获取签约摄影师列表
export function getSignPhotographerList () {
  return mainService({
    url: 'manage/group/get_cameraman_list_man',
    method: 'post'
  })
}

// 获取标签
export function getPersonTagList () {
  return mainService({
    url: 'app/person/get_tag_list',
    method: 'post'
  })
}

// 获取当前用户已选标签
export function getPersonSelectTag (data) {
  return mainService({
    url: 'app/person/person_tag',
    method: 'post',
    data: data
  })
}

// 编辑图片
export function editPersonProductPicture (data) {
  return mainService({
    url: 'gty/update_pic_extraProps',
    method: 'post',
    data: data
  })
}

// 修改用户标签 - 用于贵图云网站
export function editPersonTaglist (data) {
  return mainService({
    url: 'app/person/set_user_tag',
    method: 'post',
    data: data
  })
}
